import TourItem from './TourItem';
export default TourItem;
